export default {

  setDashboard(state, data) {
    state.dashboard = data;
  },
  
  setFeedbacks(state, data) {
    state.feedbacks = data;
  },
  setFeedbackDetails(state, data) {
    state.feedbackDetails = data;
  },

  setCampaigns(state, data) {
    state.campaigns = data;
  },
  setCampaignDetail(state, data) {
    state.campaignDetail = data;
  },

  setActiveFeedback(state, data) {
    state.activeFeedback = data;
  },

  setCreditTransaction(state, data) {
    state.creditTransaction = data;
  },

  setCustomerScore(state, data) {
    state.customerScore = data;
  },

  setScoreByCredit(state, data) {
    state.scoreByCredit = data;
  },

  setGetScoreData(state, data) {
    state.getScoreData = data;
  },

  setVendorScoreHistory(state, data) {
    state.vendorScoreHistory = data;
  },

  setVendorDiscounts(state, data) {
    state.vendorDiscounts = data;
  },

  setPrivateDiscounts(state, data) {
    state.privateDiscounts = data;
  },

  setPublicDiscounts(state, data) {
    state.publicDiscounts = data;
  },

  setScoreList(state, data) {
    state.scoreList = data;
  },

  setReceivedScores(state, data) {
    state.receivedScores = data;
  },

  setScoreDetails(state, data) {
    state.scoreDetails = data;
  },

  setScoreHistory(state, data) {
    state.scoreHistory = data;
  },

  setTransactions(state, data) {
    state.transactions = data;
  },

  setTransaction(state, data) {
    state.transaction = data;
  },


};
